import { ENTITY_SYNC_STATUS_SAVE } from 'constants/ActionTypes';

const initialState = {};

const initialEntityState = {
    data: null,
};

export default function reducer(state = initialState, action) {
    const entity = action.entity;
    const entityState = state[entity] || { ...initialEntityState };

    switch (action.type) {
        case ENTITY_SYNC_STATUS_SAVE:
            return {
                ...state,
                [entity]: {
                    ...entityState,
                    data: action.data,
                },
            };
        default:
            return state;
    }
}
